import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
const UserAvatar = (props) => {
    const { className, userIcon, bgColor = 'iv-bg-blue' } = props;
    return (_jsx("div", { className: clsx('iv-desktop-header-avatar iv-flex'), children: _jsx("div", { className: clsx(bgColor, 'iv-flex iv-items-center iv-justify-center', 'iv-h-[30px] iv-w-[30px]', 'iv-rounded-full', 'iv-text-grey-0', 'iv-text-body-3xl', 'iv-font-bold', className), children: userIcon }) }));
};
export default UserAvatar;
